module.exports = __webpack_public_path__ + "img/alert-time.d9551fc7.svg";